import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { DriverAssignmentsService } from 'app/modules/vehicle-inventory/services/driver-assignments.service';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import { EmployeeService } from 'app/modules/vehicle-inventory/services/employee.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-drivers-assignments-form',
    templateUrl: './drivers-assignments-form.component.html',
    styleUrls: ['./drivers-assignments-form.component.css'],
    standalone: false
})
export class DriversAssignmentsFormComponent  extends EntityFormComponent<Rest.InvDriverAssignment>
implements OnInit {

  @Input() entities: Rest.InvDriverAssignment[] = [];
noticeChannels: SelectItem[];
channelsList: Rest.NoticeChannel[];
title: string;

driverList: Rest.InvDriver[] = [];
driverRequestContext: any;
startDate: Date;
endDate: Date;

canUpdate: boolean;
minStartDate: Date
maxStartDate: Date;

ids: number[] = [];


constructor(
  private driverAssignmentsService: DriverAssignmentsService,
  notificationsService: NotificationsService,
  protected i18n: I18nService,
  protected authenticationService: AuthenticationService,
  public translateService: TranslateService,
  private driverService: DriverService,
  protected userTime: UserTimePipe,

) {
  super(driverAssignmentsService, notificationsService, i18n, authenticationService);
}

/**
 * Loads and evaluates all the necessary data before showing the form.
 *
 * @memberof AccessoryFormComponent
 */
ngOnInit(): void {
  this.setPermissions();
  
}

setPermissions() {
  const user = this.authenticationService.user;

  this.canUpdate = this.authenticationService.isRoleGranted('INV_DRIVER_ASSIGNMENTS_UPDATE', user);
  }

beforeShow() {

  this.title = this.translateService.instant('drivers.table.drivers');

  this.ids = [];
  if (this.entity.documents && this.entity.documents.length > 0) {
    this.entity.documents.forEach(x => this.ids.push(x.id));
  } else {
    this.ids = [-1];
  }

  this.driverRequestContext = {
    sortBy: 'employee.code',
    sortAsc: true,
    pageSize: 10,
    loadPermissions: false,
    filters: {},
  } as Rest.ListPaginationRequest;

  if (this.entity.driver) {
    this.driverRequestContext.filters['user'] = [this.entity.driver.employee.code + " " + this.entity.driver.employee.user.surname1 + " " + this.entity.driver.employee.user.surname2 + ", " + this.entity.driver.employee.user.name];
  }
  
  this.driverService.getPage(this.driverRequestContext).then((p) => {
    this.driverList = p.entities.map((driver) => ({
        ...driver,
        fullName: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
    }));
  });

  this.startDate = this.entity.startDate ? this.userTime.utcToCalendarDate(this.entity.startDate) : null;
  this.endDate = this.entity.endDate ? this.userTime.utcToCalendarDate(this.entity.endDate) : null;

  var firstDriverAssignment = this.entities[0];

  if(firstDriverAssignment.id == this.entity.id) {
      if(this.entities.length > 1){
        this.minStartDate = this.entities[1].startDate;
        this.maxStartDate = null;
      }else{
        this.minStartDate = null;
        this.maxStartDate = null;
      }
  }else{
      this.minStartDate = null;
      this.maxStartDate = this.entities[0].startDate;
  }
}


onFilterDriver(event) {
  this.driverRequestContext.filters['user'] = [event.filter ?? ''];
  this.driverService.getPage(this.driverRequestContext).then((p) => {
    this.driverList = p.entities.map((driver) => ({
      ...driver,
      fullName: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
    }));
  });
}

onChangeDriver(event) {
  this.entity.driver = event.value;
}

refresh() {
  this.return.emit();
}

protected beforeSave(): void {
  this.entity.startDate = this.startDate;
  this.entity.endDate = this.endDate;

  if(this.entity.driver){
    delete this.entity.driver.fullName;
    this.entity.driver.licenseData = null;
  }

  
}


}
